import {
  Bleed,
  Box,
  Column,
  Columns,
  Heading,
  Stack,
} from 'braid-design-system';
import type React from 'react';

interface Props {
  heading: string;
  svg: React.ReactNode;
  children: React.ReactNode;
  'data-automation'?: string;
}

export const CreateResumeBlueCard = ({
  heading,
  svg,
  children,
  'data-automation': dataAutomation,
}: Props) => (
  <Box
    borderRadius="large"
    background="formAccentSoft"
    padding="gutter"
    data-automation={dataAutomation}
  >
    <Columns space="medium" collapseBelow="tablet" alignY="center">
      <Column>
        <Stack space="medium">
          <Heading level="3" component="h2">
            {heading}
          </Heading>
          <Box>{children}</Box>
        </Stack>
      </Column>
      <Column width="content">
        <Bleed vertical="xxsmall">{svg}</Bleed>
      </Column>
    </Columns>
  </Box>
);
